import { render } from "./OfferIPA.vue?vue&type=template&id=b2adfeae&scoped=true"
import script from "./OfferIPA.vue?vue&type=script&lang=js"
export * from "./OfferIPA.vue?vue&type=script&lang=js"

import "./OfferIPA.vue?vue&type=style&index=0&id=b2adfeae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2adfeae"]])

export default __exports__